<app-header></app-header>

<div class="mainrow  finzy-container-padding-bottom col-md-12">
	<div  class="col-md-12 finzy-container-padding-2" style="text-align: center;padding: 100px 0;">		
		<img  src="https://res.cloudinary.com/finzy/image/upload/v1496432201/invest/Screen_Shot_2017-06-03_at_12.56.28_AM.png">
	</div>
</div>

<app-footer></app-footer>